var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: ["input-set", _vm.classActive, _vm.classError] },
    [
      _vm.label
        ? _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _vm._v(" "),
      _vm.tooltip
        ? _c(
            "i",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: {
                    content: _vm.tooltip,
                    classes: _vm.tooltipClasses,
                  },
                  expression:
                    "{\n            content: tooltip,\n            classes: tooltipClasses\n        }",
                },
              ],
              staticClass: "info-icon",
            },
            [
              _c("img", {
                attrs: {
                  src: "/assets/images/far-info-circle.svg",
                  alt: "info-icon",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isDropdown
        ? _c("input", {
            ref: "inputSet",
            class: ["form-control"],
            attrs: {
              type: _vm.inputType,
              name: `${this.name}`,
              placeholder: `${this.placeholder}`,
              maxlength: _vm.maxLength,
              tabindex: _vm.tabIndex,
              autocomplete: _vm.autocomplete,
            },
            domProps: { value: _vm.value },
            on: {
              "~input": function ($event) {
                return _vm.updateValue($event.target.value)
              },
              input: function ($event) {
                return _vm.updateValue($event.target.value)
              },
              focus: _vm.onFocus,
              blur: _vm.onBlur,
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.onEnter.apply(null, arguments)
              },
            },
          })
        : _c("dropdown", {
            attrs: {
              name: _vm.name,
              isNavbarDropdown: false,
              inInputSet: true,
              entries: _vm.entries,
              formatText: (x) => x,
              formatValue: (x) => x,
              selected: _vm.selected,
              active: _vm.active,
              error: _vm.hasError,
              placeholder: _vm.placeholder,
              tabIndex: _vm.tabIndex,
            },
            on: {
              "update:selected": _vm.onDropdownChange,
              onToggle: _vm.onDropdownToggle,
              dropdownOnBlur: _vm.onBlur,
              dropdownOnFocus: _vm.onFocus,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }